import NiceModal from "@ebay/nice-modal-react";
import {CustomDialog, Text} from "@bounce/shared/ui";

type Props = {
  onConfirm: (translate: boolean) => void;
};

const OfferTranslateDialog = NiceModal.create(({onConfirm}: Props) => (
  <CustomDialog
    title="Template saved"
    forceTitle
    buttonText="Translate to Spanish"
    secondaryButtonText="Skip for now"
    onClick={() => onConfirm(true)}
    onClickSecondary={() => onConfirm(false)}
    width="380px"
  >
    <Text size={14}>Would you like to auto-translate this template into Spanish now?</Text>
  </CustomDialog>
));

export default OfferTranslateDialog;
